/* eslint-disable jsx-a11y/anchor-is-valid */

import { useContext } from "react";
import 'swiper/css/bundle';
import "swiper/css/grid";
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import { Context } from "../../Context/context";
import retail from "../../assets/imgs/page/homepage1/retail.svg";
import { logoRedColor } from "../Header";


const CategorySlider = () => {
    const { browseByCategory } = useContext(Context);
    return (
        <>
            <div
                className="swiper-container swiper-group-5"
                style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                }}>
                <Swiper
                    modules={[Navigation]}
                    slidesPerView={1}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={30}
                    navigation={{
                        prevEl: ".swiper-button-prev",
                        nextEl: ".swiper-button-next",
                    }}
                    breakpoints={{
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 30,
                        },
                        575: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        767: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        991: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                        1199: {
                            slidesPerView: 5,
                            spaceBetween: 30,
                        },
                    }}
                    className="swiper-wrapper swiper-grid-jobobx">
                    {browseByCategory?.map((item, i) => (
                        <SwiperSlide key={i}>
                            <div className="swiper-slide hover-up" style={{ height: "100%" }}>
                                {/* <Link legacyBehavior href="/jobs-list"> */}
                                <a>
                                    <div
                                        className="item-logo"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: logoRedColor,
                                            maxWidth: "100%",
                                            width: "100%",
                                            minHeight: "150px",
                                            gap: "6px"
                                        }}>
                                        <div className="image-left">
                                            <img
                                                alt="kindjob"
                                                src={retail}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                textAlign: "center",
                                            }}>
                                            <h6 style={{ color: "white" }}>
                                                {item?.department_name}
                                            </h6>
                                            {/* <p className="font-xs">
                                                {item?.job_count}
                                                <span> Jobs Available</span>
                                            </p> */}
                                        </div>
                                    </div>
                                </a>
                                {/* </Link> */}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="font-lg category-text color-text-paragraph-2 wow animate__animated animate__fadeInUp">
                    <div>
                        Browsing by category can also help you discover new industries or
                        job titles <br />
                        that you may not have considered before, which can broaden your
                        horizons <br />
                        and open up new career opportunities.
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}>
                    <button
                        style={{ width: "250px" }}
                        className="buttonCustom  hover-up">
                        Learn More
                    </button>
                </div>
            </div>

            <div
                className="swiper-button-next"
                style={{
                    display: window.innerWidth < 500 && "none"
                }}
            />
            {/* <Icon className="swiper-button-nextt" style={{
                position:"absolute", right:"10px",
                fontSize:"14px",width:"20px", height:"20px"}}>
                        <ArrowForwardIosIcon style={{width:"100%", height:"100%"}}/>
                      </Icon> */}
            <div
                className="swiper-button-prev"
                style={{
                    display: window.innerWidth < 500 && "none"
                }}
            />
        </>
    );
};

export default CategorySlider;
